export enum LeadSequenceStatus {
  ACTIVE = 'active',
  FAILED = 'failed',
  SUCCESS = 'success'
}

export type LeadsModalType = 'preset' | 'create_contact' | 'edit' | 'comments'
